import React from 'react';
import { getServiceLevelDisplay } from '../../../utils/parse';
import './connection-level.scss';

export const ConnectionLevel: React.FC<{serviceLevel?: string}> = ({ serviceLevel }) => {
    const displayName = getServiceLevelDisplay(serviceLevel);
    return <div className={`connection-level ${displayName?.toLowerCase()}`}><span>{displayName}</span></div>;
};